import { Routes } from '@angular/router';
import {
  AddAbEntryComponent,
  EditAbEntryComponent,
} from '@maximizer/outlook/abentry/ui';
import { AddAppointmentComponent } from '@maximizer/outlook/appointment/ui';
import { CallLogComponent } from '@maximizer/outlook/interaction-log/ui';
import {
  AddLeadComponent,
  EditLeadComponent,
} from '@maximizer/outlook/lead/ui';
import { AddNoteComponent } from '@maximizer/outlook/note/ui';
import { AddOpportunityComponent } from '@maximizer/outlook/opportunity/ui';
import { AddCaseComponent } from '@maximizer/outlook/case/ui';
import {
  EntryDetailsComponent,
  EntryPageComponent,
  EntrySummaryComponent,
} from '@maximizer/outlook/entry/ui';
import { AddTaskComponent } from '@maximizer/outlook/task/ui';
import { TimelineComponent } from '@maximizer/outlook/timeline/ui';
import {
  OutlookMailComposeComponent,
  OutlookMailReadComponent,
  OutlookRelatedComponent,
  OutlookRelatedDetailComponent,
  OutlookCalendarComposeComponent,
  OutlookCalendarReadComponent,
} from '@maximizer/outlook/main/ui';
import { HomeComponent } from './home/home.component';
import {
  OutlookAuthorizeComponent,
  OutlookLoginComponent,
  OutlookLoginEmailComponent,
} from '@maximizer/outlook/auth/ui';
import { authenticationGuard } from './auth/auth.guard';
import { OutlookPreferencesComponent } from '@maximizer/outlook/menu/ui';
import { PageTitle } from '@maximizer/outlook/shared/domain';
import { OutlookIqBoostComponent } from '@maximizer/outlook/ai/ui';

// Route title used for page view tracking - for UI page titles use page-title.service.ts
export const routes: Routes = [
  { path: 'authorize', component: OutlookAuthorizeComponent },
  { path: 'login', component: OutlookLoginComponent },
  { path: 'login-email', component: OutlookLoginEmailComponent },
  {
    path: 'lead/add',
    component: AddLeadComponent,
    canActivate: [authenticationGuard],
    title: PageTitle.AddLead,
  },
  {
    path: 'abentry/add/:type',
    component: AddAbEntryComponent,
    canActivate: [authenticationGuard],
    title: PageTitle.AddAddressBookEntry,
  },
  {
    path: 'abentry/:id/edit',
    component: EditAbEntryComponent,
    canActivate: [authenticationGuard],
    title: PageTitle.EditAddressBookEntry,
  },
  {
    path: 'lead/:id/edit',
    component: EditLeadComponent,
    canActivate: [authenticationGuard],
    title: PageTitle.EditLead,
  },
  {
    path: ':type/:id/add-appointment',
    component: AddAppointmentComponent,
    canActivate: [authenticationGuard],
    title: PageTitle.AddAppointment,
  },
  {
    path: ':type/:id/add-call-log',
    component: CallLogComponent,
    canActivate: [authenticationGuard],
    title: PageTitle.AddCallLog,
  },
  {
    path: ':type/:id/add-opportunity',
    component: AddOpportunityComponent,
    canActivate: [authenticationGuard],
    title: PageTitle.AddOpportunity,
  },
  {
    path: ':type/:id/add-case',
    component: AddCaseComponent,
    canActivate: [authenticationGuard],
    title: PageTitle.AddCase,
  },
  {
    path: ':type/:id/add-task',
    component: AddTaskComponent,
    canActivate: [authenticationGuard],
    title: PageTitle.AddTask,
  },
  {
    path: ':type/:id/add-note',
    component: AddNoteComponent,
    canActivate: [authenticationGuard],
    title: PageTitle.AddNote,
  },
  {
    path: ':type/:id/summary',
    component: EntrySummaryComponent,
    canActivate: [authenticationGuard],
  },
  {
    path: ':type/:id/details',
    component: EntryDetailsComponent,
    canActivate: [authenticationGuard],
  },
  {
    path: ':type/:id/timeline',
    component: TimelineComponent,
    canActivate: [authenticationGuard],
  },
  {
    path: ':type/:id',
    component: EntryPageComponent,
    canActivate: [authenticationGuard],
    title: PageTitle.EntryPage,
  },
  {
    path: 'read-email',
    component: OutlookMailReadComponent,
    canActivate: [authenticationGuard],
    title: PageTitle.MailRead,
  },
  {
    path: 'compose-email',
    component: OutlookMailComposeComponent,
    canActivate: [authenticationGuard],
    title: PageTitle.MailCompose,
  },
  {
    path: 'calendar-compose',
    component: OutlookCalendarComposeComponent,
    canActivate: [authenticationGuard],
    title: PageTitle.CalendarCompose,
  },
  {
    path: 'calendar-read',
    component: OutlookCalendarReadComponent,
    canActivate: [authenticationGuard],
    title: PageTitle.CalendarRead,
  },
  {
    path: 'related',
    component: OutlookRelatedComponent,
    canActivate: [authenticationGuard],
    title: PageTitle.RelatedOpportunitiesAndCases,
  },
  {
    path: 'related/:entry/detail',
    component: OutlookRelatedDetailComponent,
    canActivate: [authenticationGuard],
    title: PageTitle.RelatedDetailOpportunitiesAndCases,
  },
  {
    path: 'preferences',
    component: OutlookPreferencesComponent,
    canActivate: [authenticationGuard],
    title: PageTitle.Preferences,
  },
  {
    path: 'iq-boost',
    component: OutlookIqBoostComponent,
    canActivate: [authenticationGuard],
    title: PageTitle.IqBoost,
  },
  { path: 'home', component: HomeComponent },
  {
    path: 'sync-configuration',
    loadChildren: () =>
      import('@maximizer/outlook-sync/ui').then(
        (outlookSyncModule) => outlookSyncModule.SYNC_CONFIGURATION_ROUTES,
      ),
  },
  { path: '**', pathMatch: 'full', redirectTo: '/home' },
];
